import http from "../services/httpService";

const apiUrl = http.getApiUrl();
const endPoint = "/ipv4pools/";
const url = apiUrl + endPoint;

export async function getIpV4Pools() {
  return await http.get(url);
}

export async function getIpV4PoolById(poolId) {
  return await http.get(url + poolId);
}

export async function getIpV4PoolByRouter(routerId) {
  return await http.get(url + "router/" + routerId);
}

export async function getIpV4PoolForRouterByType(routerId, type) {
  return await http.get(url + "router/" + routerId + "/" + type);
}

export async function getIpV4AddressesByPoolId(poolId, pageNumber, pageSize, searchQuery) {
  return await http.get(url + poolId + "/" + pageNumber + "/" + pageSize + "?searchQuery=" + searchQuery);
}

export async function getAddressesCount(poolId, searchQuery) {
  return await http.get(url + "count/" + poolId + "?searchQuery=" + searchQuery);
}

export async function deleteIpV4Pool(poolId) {
  return await http.delete(url + poolId);
}

export async function addIpV4Pool(pool) {
  return await http.post(url, pool);
}

export async function updateIpV4PoolProperty(id, property) {
  return await http.put(url + id, property);
}
